  // 列表组件
  import React, {useContext, useEffect, useRef, useState} from 'react';
  import { useTranslation } from "@/langs/useTranslation";
  import {  Table, Checkbox } from 'antd';
  import {
    Button,
  } from "@material-ui/core";
  import DeviceTableColumnsManagerModal from './DeviceTableColumnsManager/Modal';
  import {SettingOutlined} from "@ant-design/icons"
  import StoreApi from '@/apis/storeAPI';
  import _ from 'lodash';
  import {LanguageContext} from '@/langs/LanguageContext';
  import HasPermission from "@/components/commons/HasPermission";
  import { useAntdColumnResize } from 'react-antd-column-resize';

  const TableList = ({
    selectedRowKeys,
    tableLoading,
    pageSetting={
      page:0,
      page_size: 20,
      total: 0,
      order_by_column: null,// 排序相关
      order_by_desc: null
    },
    checkedAll,
    tableData,
    tableFunc,
  }) => {
    // console.log("--------selectedRowKeys------",selectedRowKeys)
    // table ref
    const tableRef = useRef(null)
    // 多语言
    const storeLang = useTranslation("store");
    // 列设置弹窗
    const [columnsManagerModalOpen,setColumnsManagerModalOpen] = useState(false)
    // 使用的列数据
    const [columns,setColumns] = useState([])
    // 缓存的列数据
    const [defaultColumns, setDefaultColumns] = useState([])

    const contextValue = useContext(LanguageContext);

    const handleColumnsClose = () => {
      setColumnsManagerModalOpen(false);
    };
    const handleColumnsConfirm = async(data) => {
      const requestData = _.map(_.filter(data,d=>!d.invisible),item=>{
        return {
          field: item.key,
          show: item.visible
        }
      })
      // const field = [{"field":"store_name","show":true},{"field":"store_code","show":true},{"field":"status","show":true},{"field":"invisible_user_count","show":true},{"field":"devices_count","show":true},{"field":"name","show":true},{"field":"parent_name","show":true},{"field":"store_address","show":true},{"field":"contact","show":true},{"field":"contact_phone","show":true}]

      const res = await StoreApi.SetTableColumnConfig({
        table: "groups",
        list_fields: requestData
      })

      if(res.status === "success") {
        setTableColumn()
      }

      setColumnsManagerModalOpen(false)

    }

    const defaultColumnsSetting = [
      {
        title: `${storeLang.t({defaultMessage: '门店编码'})}`,
        ellipsis: true,
        dataIndex: 'store_code',
        key: 'store_code',
        align: 'left',
        width: 150,
        visible: true,
        sortOrder: pageSetting.order_by_column === 'store_code' ? pageSetting.order_by_desc : '',
        sorter: (a, b) => false,
        render: (_,record) => {
          return record.info.store_code
        },
      },
      {
        title: `${storeLang.t({defaultMessage: '门店名称'})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'name',
        disabled: 'true',
        key: 'name',
        width: 150,
        align: 'left',
        sortOrder: pageSetting.order_by_column === 'name' ? pageSetting.order_by_desc : '',
        sorter: (a, b) => false,
        render: (text,record) => {
          return <span className={`name-span`} onClick={()=>{tableFunc.handleStoreDetail(record)}}>{record.name}</span>
          // return record.name
        },
      },
      {
        title: `${storeLang.t({defaultMessage: '门店简称'})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'store_name',
        key: 'store_name',
        width: 170,
        align: 'left',
        sortOrder: pageSetting.order_by_column === 'store_name' ? pageSetting.order_by_desc : '',
        sorter: (a, b) => false,
        render: (text,record) => {
          return record.info.store_name
        },
      },
      {
        title: `${storeLang.t({defaultMessage: '上层'})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'parent_name',
        width: 120,
        key: 'parent_name',
        sorter: (a, b) => false,
        sortOrder: pageSetting.order_by_column === 'parent_name' ? pageSetting.order_by_desc : '',
        render: (text,record) => {
          return record.parent_name
        },
      },
      {
        title: `${storeLang.t({defaultMessage: '状态'})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        width: 140,
        render: (text,record) => {
          const statusOption = {
            0: storeLang.t({defaultMessage:"未开业"}),
            1: storeLang.t({defaultMessage:"营业"}),
            2: storeLang.t({defaultMessage:"停业"}),
            3: storeLang.t({defaultMessage:"闭店"}),
          }
          return <span className={`status status-${record.info.status}`}>{`${statusOption[record.info.status]}`}</span>
        },
      },
      {
        title: `${storeLang.t({defaultMessage:"门店地址"})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'store_address',
        key: 'store_address',
        align: 'left',
        width: 150,
        render: (text,record) => {
          return record.info.store_address
        },
      },
      {
        title: `${storeLang.t({defaultMessage:"备注"})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'remark',
        key: 'remark',
        align: 'left',
        width: 150,
        render: (text,record) => {
          return record.info.remark
        },
      },
      {
        title: `${storeLang.t({defaultMessage:"联系人"})}`,
        ellipsis: true,
        visible: false,
        dataIndex: 'contact',
        key: 'contact',
        align: 'center',
        width: 120,
        render: (text,record) => {
          return record.info.contact
        },
      },
      {
        title: `${storeLang.t({defaultMessage:"联系人电话"})}`,
        ellipsis: true,
        visible: false,
        dataIndex: 'contact_phone',
        key: 'contact_phone',
        align: 'left',
        width: 160,
        render: (text,record) => {
          return record.info.contact_phone
        },
      },
      {
        title: `${storeLang.t({defaultMessage:"负责人"})}`,
        ellipsis: true,
        visible: false,
        dataIndex: 'charge',
        key: 'charge',
        align: 'center',
        width: 120,
        render: (text,record) => {
          return record.info.charge
        },
      },
      {
        title: `${storeLang.t({defaultMessage:"负责人电话"})}`,
        ellipsis: true,
        visible: false,
        dataIndex: 'charge_phone',
        key: 'charge_phone',
        align: 'left',
        width: 160,
        render: (text,record) => {
          return record.info.charge_phone
        },
      },
      {
        title: `${storeLang.t({defaultMessage:"设备数"})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'devices_count',
        key: 'devices_count',
        align: 'center',
        width: 80,
        render: (text,record) => {
          return <a>{text}</a>
        },
      },
      {
        title: `${storeLang.t({defaultMessage:"账号"})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'invisible_user_count',
        key: 'invisible_user_count',
        align: 'center',
        width: 80,
        render: (text,record) => {
          return <a onClick={()=>{tableFunc.handleStoreAccount(record)}}>{text}</a>
        },
      }
    ]

    const defaultColumnsOperationSetting = [
      {
        title: ()=>{
          return <div className={`operation-column`}>
            <span>{storeLang.t({defaultMessage:"操作"})}</span>
            <div className={`setting-btn`} onClick={()=>{setColumnsManagerModalOpen(true)}}><SettingOutlined style={{ fontSize: '20px' }}/></div>
          </div>
        },
        realTitle: `${storeLang.t({defaultMessage:"操作"})}`,// 用于列自定义显示
        invisible: true, // 用于 display none
        visible: true,   // 用于 disabled
        key: 'action',
        align: 'center',
        fixed: 'right',
        width: 300,
        render: (_, record) => (
          <>
            <span className={`operation-span`} onClick={()=>{tableFunc.handleStoreDetail(record)}}>{storeLang.t({defaultMessage:"查看"})}</span>
            <HasPermission permission="merchant_maintain_group">
              <span className={`operation-span`} onClick={()=>{tableFunc.handleStoreEdit(record)}}>{storeLang.t({defaultMessage:"编辑"})}</span>
            </HasPermission>
            <HasPermission permission="merchant_token">
              <span className={`operation-span`} onClick={()=>{tableFunc.handleStoreSetting(record)}}>{storeLang.t({defaultMessage:"门店配置"})}</span>
            </HasPermission>
            <HasPermission permission="merchant_maintain_group">
              <span className={`operation-span delete`} onClick={()=>{tableFunc.handleStoreDel(record)}}>{storeLang.t({defaultMessage:"删除"})}</span>
            </HasPermission>
          </>
        ),
      }
    ]



    // 获取当前数据库中存储的字段顺序值
    const getTableColumn = async () => {
      // 获取云端数据
      const serverColumnSetting = await StoreApi.GetTableColumnConfig({
        table: 'groups'
      })
      let reloadColumns = []
      if(serverColumnSetting.config && serverColumnSetting.config.length>0){
        // 进行本地和云端进行排序
        _.each(serverColumnSetting.config,serverItem=>{
          const localItem = _.find(defaultColumnsSetting,localItem=> localItem.key === serverItem.field)
          if(localItem) reloadColumns.push({
            ...localItem,
            visible: serverItem.show
          })
        })
      }else {
        reloadColumns = defaultColumnsSetting
      }

      // 操作追加到最后
      reloadColumns = reloadColumns.concat(defaultColumnsOperationSetting)
      return reloadColumns
    }

    const setTableColumn = async() => {
      // 通过云端的数据进行重新排序和收藏
      const reloadColumns = await getTableColumn()
      setDefaultColumns(_.cloneDeepWith(defaultColumnsSetting.concat(defaultColumnsOperationSetting),true))
      setColumns(_.cloneDeepWith(reloadColumns,true))
    }


    const { resizableColumns, components, tableWidth, resetColumns } =
      useAntdColumnResize(() => {
        return { columns : columns.filter(v => v.visible), minWidth: 100, maxWidth: 500 };
      }, [columns,tableData]);

    useEffect(()=>{
      setTableColumn()
      // setOrderByColumn(pageSetting.order_by_column)
    },[pageSetting,contextValue])


    return <>
      <Table ref={tableRef}
             rowKey="id"
             columns={resizableColumns.filter(v => v.visible)}
             components={components}
             dataSource={tableData}
             onChange={tableFunc.onChange}
             loading={tableLoading}
             rowSelection={{
               fixed : true,
               selectedRowKeys: selectedRowKeys,
               type: "checkbox",
               onChange: tableFunc.onSelectChange,
               preserveSelectedRowKeys: true
             }}
             scroll={{y: '200',x: tableWidth }}
             pagination={{
               simple: false,
               current: pageSetting.page,
               pageSize: pageSetting.page_size,
               showSizeChanger: true,
               showTotal : (total) => `${storeLang.t({defaultMessage: "共{total}条"},{total: total}) }`,
               total:pageSetting.total
             }}
             footer={()=>{
               return <div className={`my-table-footer`}>
                 {/*<Checkbox checked={checkedAll} onChange={tableFunc.handleChangeCheckedAll}>{storeLang.t({defaultMessage: '全选'})}</Checkbox>*/}
                 <Button variant="outlined" color="primary" size="small" onClick={()=> {tableFunc.handleUpdateStates()}}>
                   {storeLang.t({defaultMessage: '更新状态'})}
                 </Button>

                 <Button variant="outlined" color="secondary" size="small" onClick={()=> { tableFunc.handleDeleteAll()}}>
                   {storeLang.t({defaultMessage: '删除'})}
                 </Button>
               </div>
             }}
      />
      <DeviceTableColumnsManagerModal
        list={columns}
        getDefaultColumns={()=>{return defaultColumns}}
        open={columnsManagerModalOpen}
        onClose={handleColumnsClose}
        onConfirm={handleColumnsConfirm}
      />
    </>
  }
  export default React.memo(TableList)
